import React, { useContext } from "react";
import "../styles/bus_stop.css";
import { ThemeContext } from "../ThemeContext";
import { useLocation, useNavigate } from "react-router-dom";
import { ReactComponent as ElectricityIcon } from "../assets/icons/electric.svg";
import { ReactComponent as CharcoalIcon } from "../assets/icons/charcoal.svg";
import { ReactComponent as GasolineIcon } from "../assets/icons/gasoline.svg";
import { ReactComponent as DieselIcon } from "../assets/icons/diesel.svg";
import { ReactComponent as GasIcon } from "../assets/icons/gas.svg";
import { ReactComponent as NaturalGasIcon } from "../assets/icons/naturalgas.svg";
import { ReactComponent as BatteryIcon } from "../assets/icons/battery.svg";
import { ReactComponent as HydrogenIcon } from "../assets/icons/hydrogen.svg";

const BusStop = () => {
  const { theme, category, setCategory } = useContext(ThemeContext);
  const navigate = useNavigate();
  const location = useLocation(); // 获取当前路由

  const energySources = [
    {
      category: "electric",
      Icon: ElectricityIcon,
      text: "外源电",
      color: "#9AFF6B",
    }, // 电能
    {
      category: "charcoal",
      Icon: CharcoalIcon,
      text: "木炭",
      color: "#AAA",
    }, // 木炭
    {
      category: "gasoline",
      Icon: GasolineIcon,
      text: "汽油",
      color: "#F1E29E",
    }, // 汽油
    { category: "diesel", Icon: DieselIcon, text: "柴油", color: "#F9CE4E" }, // 柴油
    { category: "coalgas", Icon: GasIcon, text: "煤气", color: "#DDD" }, // 煤气
    {
      category: "naturalgas",
      Icon: NaturalGasIcon,
      text: "天然气",
      color: "#FFC4E1",
    }, // 天然气
    {
      category: "battery",
      Icon: BatteryIcon,
      text: "电池电",
      color: "#9AFF6B",
    },
    {
      category: "hydrogen",
      Icon: HydrogenIcon,
      text: "氢能源",
      color: "#8AE0FF",
    }, // 氢能源
  ];

  const isContentPage = location.pathname === "/content"; // 判断是否在 /content 页面
  return (
    <div className="busstop">
      <div className="start-button">
        <button
          className="start"
          onClick={() => {
            if (category === "babybus") {
              setCategory("electric");
            }
            if (isContentPage) {
              // 如果在 /content 页面，返回首页
              navigate("/");
            } else {
              // 如果在首页，跳转到 /content
              navigate("/content");
            }
          }}
        >
          {/* <img src="../assets/icons/button_start.png" alt="Start" /> */}
          {isContentPage ? (
            <svg // BACK 图标
              width="355"
              height="99"
              viewBox="0 0 355 99"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="4.36133"
                y="5"
                width="345.518"
                height="89.3385"
                rx="44.6693"
                fill="white"
              />
              <rect
                x="4.36133"
                y="5"
                width="345.518"
                height="89.3385"
                rx="44.6693"
                stroke="black"
                stroke-width="8.71595"
              />
              <path
                d="M66.6304 34.7929L92.3973 49.6694L66.6304 64.5459L66.6304 34.7929Z"
                fill="black"
              />
              <path
                d="M105.641 68.6689V30.0184H121.116C123.96 30.0184 126.331 30.4399 128.231 31.2828C130.131 32.1258 131.559 33.2959 132.515 34.7931C133.472 36.2777 133.95 37.9888 133.95 39.9264C133.95 41.4362 133.648 42.7635 133.044 43.9084C132.44 45.0408 131.609 45.9718 130.553 46.7015C129.508 47.4187 128.313 47.9282 126.967 48.2302V48.6076C128.439 48.6705 129.817 49.0857 131.1 49.8532C132.396 50.6207 133.446 51.6964 134.252 53.0804C135.057 54.4518 135.459 56.0874 135.459 57.9872C135.459 60.038 134.95 61.8686 133.931 63.4791C132.924 65.0769 131.433 66.3414 129.458 67.2724C127.483 68.2034 125.048 68.6689 122.154 68.6689H105.641ZM113.813 61.9881H120.475C122.752 61.9881 124.413 61.5541 125.457 60.6859C126.501 59.8052 127.023 58.6351 127.023 57.1757C127.023 56.1063 126.766 55.1626 126.25 54.3448C125.734 53.527 124.998 52.8854 124.042 52.4199C123.098 51.9543 121.972 51.7216 120.663 51.7216H113.813V61.9881ZM113.813 46.192H119.871C120.991 46.192 121.985 45.997 122.853 45.6069C123.733 45.2043 124.425 44.6382 124.929 43.9084C125.444 43.1787 125.702 42.3043 125.702 41.2852C125.702 39.8886 125.205 38.7626 124.211 37.907C123.23 37.0515 121.834 36.6237 120.022 36.6237H113.813V46.192ZM147.439 68.6689H138.682L152.025 30.0184H162.555L175.879 68.6689H167.122L157.441 38.8506H157.139L147.439 68.6689ZM146.891 53.4767H167.575V59.8556H146.891V53.4767ZM212.817 43.5499H204.551C204.4 42.4804 204.092 41.5305 203.626 40.7001C203.161 39.8572 202.563 39.14 201.833 38.5487C201.104 37.9573 200.261 37.5044 199.305 37.1899C198.361 36.8753 197.336 36.7181 196.228 36.7181C194.228 36.7181 192.485 37.215 191.001 38.209C189.516 39.1903 188.365 40.6246 187.547 42.5119C186.729 44.3865 186.32 46.6638 186.32 49.3437C186.32 52.099 186.729 54.414 187.547 56.2887C188.377 58.1633 189.535 59.5788 191.02 60.535C192.504 61.4912 194.222 61.9693 196.172 61.9693C197.266 61.9693 198.279 61.8246 199.21 61.5352C200.154 61.2458 200.99 60.8243 201.72 60.2708C202.45 59.7046 203.054 59.0189 203.532 58.2137C204.023 57.4084 204.362 56.49 204.551 55.4583L212.817 55.496C212.603 57.27 212.069 58.9811 211.213 60.6293C210.37 62.2649 209.231 63.7307 207.797 65.0266C206.375 66.3099 204.677 67.329 202.702 68.0839C200.739 68.8262 198.518 69.1974 196.04 69.1974C192.592 69.1974 189.51 68.4173 186.792 66.8572C184.087 65.2971 181.948 63.0387 180.376 60.082C178.815 57.1254 178.035 53.5459 178.035 49.3437C178.035 45.1288 178.828 41.5431 180.413 38.5864C181.999 35.6298 184.15 33.3777 186.868 31.8301C189.585 30.27 192.643 29.49 196.04 29.49C198.279 29.49 200.355 29.8045 202.268 30.4336C204.192 31.0627 205.897 31.9811 207.382 33.1889C208.867 34.3842 210.074 35.8499 211.005 37.5862C211.949 39.3224 212.553 41.3103 212.817 43.5499ZM218.677 68.6689V30.0184H226.849V47.0601H227.358L241.267 30.0184H251.062L236.719 47.3243L251.232 68.6689H241.456L230.869 52.7784L226.849 57.6852V68.6689H218.677Z"
                fill="black"
              />
              <path
                d="M287.611 34.7929L261.844 49.6694L287.611 64.5459L287.611 34.7929Z"
                fill="black"
              />
            </svg>
          ) : (
            <svg // START 图标
              width="355"
              height="99"
              viewBox="0 0 355 99"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="4.36133"
                y="5"
                width="345.518"
                height="89.3385"
                rx="44.6693"
                fill="white"
              />
              <rect
                x="4.36133"
                y="5"
                width="345.518"
                height="89.3385"
                rx="44.6693"
                stroke="black"
                stroke-width="8.71595"
              />
              <path
                d="M53.6304 34.7929L79.3973 49.6694L53.6304 64.5459L53.6304 34.7929Z"
                fill="#FF02C0"
              />
              <path
                d="M113.582 41.1342C113.431 39.6118 112.783 38.4292 111.638 37.5862C110.493 36.7432 108.939 36.3217 106.976 36.3217C105.643 36.3217 104.517 36.5105 103.598 36.8879C102.68 37.2528 101.975 37.7623 101.484 38.4166C101.006 39.0708 100.767 39.8131 100.767 40.6435C100.742 41.3355 100.887 41.9394 101.201 42.4553C101.529 42.9711 101.975 43.4177 102.541 43.7952C103.107 44.1601 103.762 44.4809 104.504 44.7577C105.246 45.0219 106.039 45.2484 106.882 45.4371L110.354 46.2675C112.04 46.6449 113.588 47.1482 114.997 47.7773C116.406 48.4063 117.627 49.1801 118.658 50.0986C119.69 51.017 120.489 52.099 121.055 53.3446C121.634 54.5902 121.93 56.0182 121.942 57.6286C121.93 59.994 121.326 62.0448 120.13 63.781C118.948 65.5047 117.237 66.8446 114.997 67.8008C112.77 68.7444 110.084 69.2162 106.939 69.2162C103.818 69.2162 101.101 68.7381 98.7857 67.7819C96.4833 66.8257 94.6841 65.4103 93.3882 63.5357C92.1049 61.6484 91.4318 59.3146 91.3689 56.534H99.2764C99.3645 57.8299 99.7356 58.9119 100.39 59.7801C101.057 60.6356 101.944 61.2836 103.051 61.7239C104.171 62.1517 105.435 62.3656 106.844 62.3656C108.228 62.3656 109.43 62.1643 110.449 61.7617C111.481 61.3591 112.279 60.7992 112.846 60.082C113.412 59.3649 113.695 58.5408 113.695 57.6098C113.695 56.7416 113.437 56.0119 112.921 55.4206C112.418 54.8292 111.676 54.326 110.694 53.9108C109.725 53.4956 108.536 53.1181 107.127 52.7784L102.919 51.7216C99.6601 50.9289 97.0872 49.6897 95.2 48.0037C93.3128 46.3178 92.3754 44.0468 92.388 41.1908C92.3754 38.8506 92.9982 36.8061 94.2564 35.0573C95.5271 33.3085 97.2697 31.9434 99.484 30.962C101.698 29.9806 104.215 29.49 107.033 29.49C109.902 29.49 112.405 29.9806 114.544 30.962C116.696 31.9434 118.369 33.3085 119.564 35.0573C120.759 36.8061 121.376 38.8318 121.414 41.1342H113.582ZM125.967 36.7558V30.0184H157.71V36.7558H145.877V68.6689H137.8V36.7558H125.967ZM164.877 68.6689H156.12L169.463 30.0184H179.993L193.317 68.6689H184.561L174.879 38.8506H174.577L164.877 68.6689ZM164.329 53.4767H185.013V59.8556H164.329V53.4767ZM197.969 68.6689V30.0184H213.218C216.137 30.0184 218.628 30.5405 220.692 31.5848C222.768 32.6165 224.347 34.0822 225.429 35.982C226.523 37.8693 227.071 40.0899 227.071 42.644C227.071 45.2106 226.517 47.4187 225.41 49.2682C224.303 51.1051 222.698 52.5142 220.597 53.4956C218.509 54.4769 215.98 54.9676 213.011 54.9676H202.801V48.4H211.69C213.25 48.4 214.546 48.1862 215.577 47.7584C216.609 47.3306 217.376 46.689 217.88 45.8334C218.396 44.9779 218.653 43.9147 218.653 42.644C218.653 41.3607 218.396 40.2786 217.88 39.3979C217.376 38.5172 216.603 37.8504 215.558 37.3975C214.527 36.9319 213.224 36.6992 211.652 36.6992H206.141V68.6689H197.969ZM218.842 51.0799L228.448 68.6689H219.427L210.029 51.0799H218.842ZM231.373 36.7558V30.0184H263.117V36.7558H251.284V68.6689H243.206V36.7558H231.373Z"
                fill="black"
              />
              <path
                d="M300.611 34.7929L274.844 49.6694L300.611 64.5459L300.611 34.7929Z"
                fill="#FF02C0"
              />
            </svg>
          )}
        </button>
      </div>

      {/* Energy Source Buttons */}
      <div className="energy-list">
        {energySources.map((item) => (
          <div
            key={item.category}
            className={`energy-item ${
              item.category === "electric"
                ? "top-border"
                : item.category === "hydrogen"
            }`}
          >
            <button
              style={{ "--hover-bg": item.color }}
              onClick={() => {
                setCategory(item.category);
                console.log("item: " + item.category);
              }}
              className={`energy-button ${
                category === item.category ? "selected" : ""
              }`}
            >
              <span className="icon">
                <item.Icon className="icon-svg" />
              </span>
              <span className="text">{item.text}</span>
            </button>
          </div>
        ))}
      </div>

      {/* Electric Pole */}
      <div className="electric-pole"></div>
    </div>
  );
};

export default BusStop;
